import * as React from "react"
import styled from "styled-components"
import Column from "../../components/column"
import theme from "../../theme"
import { FetchSingleListingUnits } from "../../generated/graphql"
import { property_highlights, PARKING_HIGHLIGHTS } from "../../constants/highlights.constant"
import Text from "../text"

interface Props {
  propertyType: string | undefined
  units: Array<FetchSingleListingUnits> | null
}

const Highlight = styled(Column as any)`
  align-items: center;
  width: 50%;
  margin-bottom: ${theme.space[2]}px;
  &:last-of-type {
    margin-right: 0;
  }
  @media (min-width: ${theme.breakpoints[0]}) {
    width: 50%;
    margin-right: 0;
  }
  @media (min-width: ${theme.breakpoints[1]}) {
    width: 33%;
    margin-right: ${theme.space[5]}px;
  }
  @media (min-width: ${theme.breakpoints[2]}) {
    width: auto;
  }
`

const Icon = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 10px;
`
const Grid = styled.div<any>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: ${props => props.marginBottom}px;
`

const SingleListingHighlights = ({ propertyType, units }: Props) => {
  /*Will get the proper object from the array pets_highlights */
  const [property] = property_highlights.filter(elem => elem.value === propertyType)
  const garage = units ? units.find(unit => unit.parking === PARKING_HIGHLIGHTS.GARAGE) : undefined
  const hasAvailableUnits = units && units.some(u => u.available === true)
  return (
    <React.Fragment>
      <Grid marginBottom={33}>
        <Highlight>
          <Icon src={property.icon} alt="propertyType" />
          <Text fontWeight={600}>{property.name}</Text>
        </Highlight>
        {hasAvailableUnits && (
          <Highlight>
            <Icon src="/images/checked.svg" alt="available icon" />
            <Text fontWeight={600}>Available units</Text>
          </Highlight>
        )}
        {garage && (
          <Highlight>
            <Icon src="/images/car.svg" alt="garage icon" />
            <Text fontWeight={600}>Garage</Text>
          </Highlight>
        )}
      </Grid>
    </React.Fragment>
  )
}

export default SingleListingHighlights
